import axios from "axios";
import authHeader from "@/Api/AuthHeader";

const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getClassmate(teacher_id) {
      return axios.get(URL_API + `teacher-classmate?teacher_id=${teacher_id}`, {
        headers: authHeader(),
      });
    },
    findClassmateByYear(year, teacher_id) {
      return axios.get(
        URL_API +
          `find-teacher-classmateByYear?year=${year}&teacher_id=${teacher_id}`,
        {
          headers: authHeader(),
        }
      );
    },
    getFirstYearTeacherAlocated(teacher_id) {
      return axios.get(
        URL_API + `teacher-alocated-year?teacher_id=${teacher_id}`,
        {
          headers: authHeader(),
        }
      );
    },
    getMyDatas() {
      return axios.get(URL_API + "teacher-profile", { headers: authHeader() });
    },
    async getTurmas() {
      try {
        const resp = await axios.get(URL_API + "teacher-profile", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getSubjects() {
      try {
        const resp = await axios.get(URL_API + "teacher-profile", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    getClassmateFormula() {
      return axios.get(URL_API + "getClassmateFormula", {
        headers: authHeader(),
      });
    },

    async getStudentByClassMates(classmate_id, subject_id) {
      try {
        const resp = await axios.get(
          URL_API +
            `list-students-by-turma?classmate_id=${classmate_id}&subject_id=${subject_id}`,

          { headers: authHeader() }
        );
        return resp.data;
      } catch (error) {
        return error;
      }
    },
    async getStudentByClassMatesPreviewMarks(classmate_id, subject_id) {
      try {
        const resp = await axios.get(
          URL_API +
            `export-marks-preview?classmate_id=${classmate_id}&subject_id=${subject_id}`,
          {
            headers: authHeader(),
          }
        );
        return resp.data;
      } catch (error) {
        return error;
      }
    },

    async getStudentByClassMatesExport(classmate_id, subject_id) {
      try {
        const resp = await axios.get(
          URL_API +
            `export-marks?classmate_id=${classmate_id}&subject_id=${subject_id}`,
          {
            headers: authHeader(),
          }
        );
        return resp.data;
      } catch (error) {
        return error;
      }
    },
    async getStudentByOnlyClassMatesExport(classmate_id) {
      try {
        return await axios.get(
          URL_API + `exportMarksByClassmate?classmate_id=${classmate_id}`,
          {
            headers: authHeader(),
          }
        );
      } catch (error) {
        return error;
      }
    },

    async getLectures(subject_id) {
      try {
        const resp = await axios.get(URL_API + "get-lectures/" + subject_id, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async submitData(weights, classmate, subject, removeWeight) {
      return await axios.post(
        URL_API + `createFormula?subject_id=${subject}&classmate=${classmate}`,
        {
          weights: weights,
          removeWeight: removeWeight,
        },
        { headers: authHeader() }
      );
    },

    async getAssessmentExams() {
      return axios.get(URL_API + "assessment_exames", {
        headers: authHeader(),
      });
    },
    async getAssessmentExamsResults(classmate_id) {
      return axios.get(
        URL_API + `getAssessmentExamsResults?classmate_id=${classmate_id}`,
        {
          headers: authHeader(),
        }
      );
    },

    async getAllFormulas() {
      try {
        const resp = await axios.get(URL_API + "getAllFormulas", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },
    async getFormulaByClass(classmate_id, subject_id) {
      try {
        const response = await axios.get(
          URL_API +
            `get-formula-by-classmate?classmate_id=${classmate_id}&subject_id=${subject_id}`,
          { headers: authHeader() }
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },
    async getFormulaByClassmate(
      course_id,
      subject_id,
      academic_year,
      student_id = null
    ) {
      try {
        const response = await axios.get(
          URL_API +
            `get-formula-by-classmateById?course_id=${course_id}&subject_id=${subject_id}&year=${academic_year}&student_id=${student_id}`,
          { headers: authHeader() }
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },

    async getFormulaById(classmate_id, subject_id, academic_year) {
      return await axios.get(
        URL_API +
          `getFormulaClassmateId?classmate_id=${classmate_id}&subject_id=${subject_id}&year=${academic_year}`,
        { headers: authHeader() }
      );
    },
    async DeleteDataTest(id) {
      try {
        const resp = await axios.delete(URL_API + "DeleteFormula/" + id, {
          headers: authHeader(),
        });
      } catch (error) {
        return error;
      }
    },
    async updateFormula(payload, id) {
      try {
        const resp = await axios.put(
          URL_API + "updateFormula/" + id,
          {
            classmate_id: payload.classmate_id,
            assessment_type: payload.assessment_type,
            percentage: payload.percentage,
          },
          { headers: authHeader() }
        );

        return resp;
      } catch (error) {
        return error;
      }
    },
    async giveAssessmentToStudents(
      data,
      subject_id,
      classmate_id,
      assessmentType
    ) {
      return await axios.post(
        URL_API +
          `give-result-to-many?subject_id=${subject_id}&classmate=${classmate_id}&assessmentType=${assessmentType}`,
        { assessments: data },
        {
          headers: authHeader(),
        }
      );
    },
    async giveExamAssessmentToStudents(
      data,
      subject_id,
      classmate_id,
      assessmentType
    ) {
      return await axios.post(
        URL_API +
          `give-exam-result-to-many?subject_id=${subject_id}&classmate=${classmate_id}&assessmentType=${assessmentType}`,
        { assessments: data },
        {
          headers: authHeader(),
        }
      );
    },
    async updateStudentResult(data, assessmentType) {
      if (data.length > 0) {
        return axios.post(
          URL_API + `update-result/${data[0].student_id}/${assessmentType}`,
          { data },
          { headers: authHeader() }
        );
      }
    },
    async checkTeacherEvaluateStudent() {
      return axios.get(URL_API + "checkTeacherEvaluateStudent", {
        headers: authHeader(),
      });
    },
    async findAllStudentSubscribedSubject(subject_id, classmate_id, course_id) {
      return axios.get(
        URL_API +
          `findAllStudentSubscribedSubject?subject_id=${subject_id}&classmate_id=${classmate_id}&course_id=${course_id}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getHistoricTeacher(teacher_id, page) {
      return axios.get(
        URL_API + `getHistoricTeacher?teacher_id=${teacher_id}&page=${page}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getAllAlocatedTeacher(
      classmate_id,
      course_id,
      subject_id,
      year,
      page
    ) {
      return axios.get(
        URL_API +
          `getAllAlocatedTeacher?page=${page}&classmate_id=${classmate_id}&course_id=${course_id}&subject_id=${subject_id}&year=${year}`,
        { headers: authHeader() }
      );
    },
  },
};
